<template>
  <div class="filter-sorting flex">
    <!--    <font-awesome-icon-->
    <!--      v-if="resValue == 'hcr_cheapest'"-->
    <!--      class="star"-->
    <!--      icon="star"></font-awesome-icon>-->
    <!--    <v-button-->
    <!--      v-else-->
    <!--      class="filter-sorting-btn"-->
    <!--      @click="sortChange"-->
    <!--    >-->
    <!--      <sortIcon-->
    <!--        class="sortIcon"-->
    <!--        :type="order"-->
    <!--        iconColor="#3485F6" />-->
    <!--    </v-button>-->

    <div class="flex-1">
      <v-select
        v-model="selectValue"
        :list="list"
        @change="selectChange"
      >
        <template slot-scope="{item}">
          <p>{{item.name}}</p>
        </template>
      </v-select>
    </div>

  </div>
</template>

<script>
export default {
  name: 'quoteSorting',
  components: {
    // sortIcon
  },
  inheritAttrs: false,
  props: {
    value:{
      type: [Number,String],
      default: ''
    },
    list:{
      type: Array,
      default: ()=>{
        return []
      }
    },
    valueKey: {
      type: String,
      default: 'id'
    },
    labelKey: {
      type: String,
      default: 'name'
    },
  },
  data() {
    return {
      order: '',   // cheapest  expensive
      selectValue : '',
      resValue : ''
    }
  },
  watch: {
    value:{
      immediate: true,
      handler(val){
        this.resValue = val
        this.getSplitValue(val)
      }
    },
    list: {
      immediate: true,
      deep: true,
      handler(val) {
        this.getFirstOption(this.value)
      }
    }
  },
  methods: {
    sortChange(){
      if(this.list && this.list.length > 0){
        if(this.order == 'cheapest'){
          this.order = 'expensive'
        }else{
          this.order = 'cheapest'
        }
        this.filterChange()
      }
    },
    getSplitValue(val){
      if(val){
        let arr = val.split('_')
        this.order = arr[1]
        this.selectValue = arr[0]
      }
      return
    },
    selectChange(val){
      let item = this.list.filter((v)=>{
        return v.id == val
      })
      this.order = item[0].default
      this.filterChange()
    },
    filterChange(){
      if(this.order && this.selectValue){
        this.resValue = `${this.selectValue}_${this.order}`
        this.$emit('input', this.resValue)
        this.$emit('change', this.resValue)
      }
      return
    },
    getFirstOption(val){
      if(this.list && this.list.length > 0){
        let item = this.list.filter((v)=>{
          return v.id == val
        })[0]
        if(!val || !item){
          this.order = this.list[0].default
          this.selectValue = this.list[0][this.valueKey]
        }
      }
    }
  }
}
</script>

<style scoped lang="scss">
.filter-sorting{
  align-items: center;
  .star{
    color: #C7CCD0;
    font-size: 16px;
    margin-right: 8px;
    padding: 0 9px;
  }
  .filter-sorting-btn{
    height: 32px;
    padding: 0 8px;
    margin-right: 8px;
    background: white;
    .sortIcon{
      fill: #3485F6;
    }
  }
  .filter-icon{
    margin-top: 8px;
  }
}
</style>
